import { ItemJsEnv } from './item_js_env';
import { CarouselItem } from '../../core/models/item';
import { Env } from '../../core/env';
import { isSoloare } from '../../core/models/js_env';

/** ItemJsEnvを操作する人 */
export class Item {
  constructor(private model: ItemJsEnv) {
    this.model = { ...model };

    if (isSoloare(Env.SITE_TYPE)) {
      this.model.rrAreaProfileItemExternalSite = {
        placementName: "tr_recom_DAD02010_002",
        displayCount: 3,
        rrAreaItems: [],
        rrAreaTitle: '',
        perView: 2
      };
      this.model.rrAreaProfileItemNormalUpper = {
        placementName: "tr_recom_DAD02010_003",
        displayCount: 30,
        rrAreaItems: [],
        rrAreaTitle: "",
        perView: 6
      };
      this.model.rrAreaProfileItemNormalLower = {
        placementName: "tr_recom_DAD02010_001",
        displayCount: 30,
        rrAreaItems: [],
        rrAreaTitle: "",
        perView: 6
      };
    } else {
      // rrAreaに表示するItemsとTitleは外部公開APIとRRサーバで取得するのでここは空で定義
      this.model.rrAreaProfileItemExternalSite = {
        placementName: "recomRR_Item_01",
        displayCount: 3,
        rrAreaItems: [],
        rrAreaTitle: '',
        perView: 2
      };
      this.model.rrAreaProfileItemNormalUpper = {
        placementName: "recomRR_Item_02",
        displayCount: 30,
        rrAreaItems: [],
        rrAreaTitle: "",
        perView: 6
      };
      this.model.rrAreaProfileItemNormalLower = {
        placementName: "recomRR_Item_03",
        displayCount: 30,
        rrAreaItems: [],
        rrAreaTitle: "",
        perView: 6
      };
      this.model.rrAreaProfileItemModal = {
        placementName: "recomRR_Modal_01",
        displayCount: 30,
        rrAreaItems: [],
        rrAreaTitle: "",
        perView: 4
      };
    }
  }

  updateModel(newModel: ItemJsEnv) {
    this.model = { ...newModel };
  }

  getModel(): ItemJsEnv {
    return {
      ...this.model
    };
  }

  setRrAreaDataItemExternalSite(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileItemExternalSite.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileItemExternalSite.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataItemNormalUpper(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileItemNormalUpper.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileItemNormalUpper.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataItemNormalLower(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileItemNormalLower.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileItemNormalLower.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataItemModal(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileItemModal.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileItemModal.rrAreaTitle = rrAreaTitle;
  }

  updateMessage(message: string) {
    this.model.message = message;
  }
}
